// src/components/pages/correlation/utils/clusteringMetrics.js

import { kmeans } from "ml-kmeans";

function euclideanDistance(pointA, pointB) {
  return Math.sqrt(
    pointA.reduce((sum, val, idx) => sum + Math.pow(val - pointB[idx], 2), 0)
  );
}

export function computeSSE(data, k) {
  const result = kmeans(data, k);
  let sse = 0;
  for (let i = 0; i < data.length; i++) {
    const clusterLabel = result.clusters[i];
    const centroidObj = result.centroids[clusterLabel];
    if (!centroidObj || !centroidObj.centroid) return Infinity;
    const centroid = centroidObj.centroid;
    let distSquared = 0;
    for (let j = 0; j < data[i].length; j++) {
      distSquared += Math.pow(data[i][j] - centroid[j], 2);
    }
    sse += distSquared;
  }
  return sse;
}

export function findElbow(ks, sseValues) {
  if (ks.length < 3) return ks[ks.length - 1];
  const firstDiff = [];
  for (let i = 1; i < sseValues.length; i++) {
    firstDiff.push(sseValues[i - 1] - sseValues[i]);
  }
  const secondDiff = [];
  for (let i = 1; i < firstDiff.length; i++) {
    secondDiff.push(firstDiff[i] - firstDiff[i - 1]);
  }
  let maxIndex = 0;
  let maxSecondDiff = -Infinity;
  for (let i = 0; i < secondDiff.length; i++) {
    if (secondDiff[i] > maxSecondDiff) {
      maxSecondDiff = secondDiff[i];
      maxIndex = i;
    }
  }
  return ks[maxIndex + 2];
}

export function computeSilhouetteScore(data, labels) {
  const n = data.length;
  let totalSilhouette = 0;
  for (let i = 0; i < n; i++) {
    let sameClusterDistances = [];
    let otherClusterDistances = {};
    for (let j = 0; j < n; j++) {
      if (i === j) continue;
      const dist = euclideanDistance(data[i], data[j]);
      if (labels[i] === labels[j]) {
        sameClusterDistances.push(dist);
      } else {
        if (!otherClusterDistances[labels[j]]) {
          otherClusterDistances[labels[j]] = [];
        }
        otherClusterDistances[labels[j]].push(dist);
      }
    }
    const a = sameClusterDistances.length > 0
      ? sameClusterDistances.reduce((sum, d) => sum + d, 0) / sameClusterDistances.length
      : 0;
    let b = Infinity;
    for (const key in otherClusterDistances) {
      const avg = otherClusterDistances[key].reduce((sum, d) => sum + d, 0) / otherClusterDistances[key].length;
      if (avg < b) b = avg;
    }
    const s = (b - a) / (Math.max(a, b) || 1);
    totalSilhouette += s;
  }
  return totalSilhouette / n;
}